import { enableProdMode, provideZonelessChangeDetection, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { environment } from './environments/environment';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { DateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from './app/custom-date-adapter';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app/app.routes';
import { DateAdapter as AngularCalendarDateAdapter, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppComponent } from './app/app.component';
import { db, functions } from './app/app.component';
import {
  CLEANUP_FIRESTORE,
  CLEANUP_FUNCTIONS,
} from './app/admin-tools/dialogs/clean-orphaned-organisation-users/clean-orphaned-organisation-users.service';

registerLocaleData(localeNl);

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

if (environment.production) {
  enableProdMode();
  if (localStorage.getItem('testMode') !== 'true') {
    window.console.log = window.console.warn = window.console.info = function () {};
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding()),
    provideCalendar({
      provide: AngularCalendarDateAdapter,
      useFactory: adapterFactory,
    }),
    provideNativeDateAdapter(),
    { provide: LOCALE_ID, useValue: 'nl' },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    { provide: CLEANUP_FIRESTORE, useValue: db },
    { provide: CLEANUP_FUNCTIONS, useValue: functions },
  ],
}).catch((err) => console.error(err));
